import PropTypes from "prop-types";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

function ClickableRAGStatusWrapper(props) {
  const { to, children, ...rest } = props;
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(to);
  }, [navigate, to]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleClick();
      }
    },
    [handleClick]
  );

  return (
    <span
      role="button"
      tabIndex={0}
      style={{ cursor: "pointer" }}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {children}
    </span>
  );
}

ClickableRAGStatusWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};

export default ClickableRAGStatusWrapper;
